import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Handshake, Database, Lock, MonitorPlay } from 'lucide-react';
export function MoatSlide() {
  const pillars = [{
    icon: Brain,
    title: 'Medical Storytelling',
    desc: 'Codified pharma expertise & intelligence',
    color: 'text-pink-600',
    bg: 'bg-pink-50',
    border: 'border-pink-200'
  }, {
    icon: MonitorPlay,
    title: 'Short Format Interactive Engagement Platform',
    desc: 'Proprietary engagement layer driving measurable outcomes',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200'
  }, {
    icon: Handshake,
    title: 'Pharma Distribution',
    desc: 'Deep enterprise relationships & access',
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    border: 'border-blue-200'
  }, {
    icon: Database,
    title: 'Behavioural Dataset',
    desc: 'Privacy-safe HCP insights compound performance',
    color: 'text-purple-600',
    bg: 'bg-purple-50',
    border: 'border-purple-200'
  }];
  return <div className="h-full flex flex-col justify-center" data-id="element-243">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12" data-id="element-244">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: idx * 0.2
      }} className={`p-6 rounded-2xl ${pillar.bg} border ${pillar.border} relative overflow-hidden group`} data-id="element-245">
            <div className={`w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-4 ${pillar.color} shadow-sm`} data-id="element-246">
              <pillar.icon className="w-6 h-6" data-id="element-247" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-248">
              {pillar.title}
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-249">
              {pillar.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.8
    }} className="relative p-8 rounded-3xl bg-purple-50 border border-purple-200 text-center max-w-3xl mx-auto w-full" data-id="element-250">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-purple-600 flex items-center justify-center shadow-lg shadow-purple-200 border-4 border-white" data-id="element-251">
          <Lock className="w-5 h-5 text-white" data-id="element-252" />
        </div>

        <h3 className="text-2xl font-bold text-gray-900 mb-2 mt-2" data-id="element-253">
          Unbreakable Flywheel
        </h3>
        <p className="text-purple-600" data-id="element-254">
          Deep medical intelligence + pharma access + behavioral data create a
          moat no broad player can match in this regulated vertical.
        </p>
      </motion.div>
    </div>;
}